(function () {
  var MOBILE_MAX = 767;
  var PC_VISIBLE = 3;

  function setButtonState(btn, disabled) {
    if (!btn) return;
    btn.classList.toggle("is-disabled", disabled);
    btn.setAttribute("aria-disabled", disabled ? "true" : "false");
    btn.tabIndex = disabled ? -1 : 0;
  }

  function isMobileLayout() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function shouldUseStaticGrid(slideCount) {
    return !isMobileLayout() && slideCount <= PC_VISIBLE;
  }

  function getEdgeSlideIndex(swiper, edge) {
    if (!swiper || !swiper.slides || !swiper.slides.length) return -1;

    var containerRect = swiper.el.getBoundingClientRect();
    var found = -1;

    for (var i = 0; i < swiper.slides.length; i++) {
      var slideRect = swiper.slides[i].getBoundingClientRect();
      var isVisible =
        slideRect.right > containerRect.left + 1 &&
        slideRect.left < containerRect.right - 1;

      if (!isVisible) continue;

      if (edge === "start") {
        if (found === -1) found = i;
      } else {
        found = i;
      }
    }

    return found;
  }

  function shouldEnableLoop(slideCount, staticGrid) {
    return !staticGrid && slideCount > 1;
  }

  function updateNavState(swiper, prevButtons, nextButtons, slideCount) {
    if (!swiper || swiper.destroyed) return;

    var staticGrid = shouldUseStaticGrid(slideCount);

    if (swiper.params.loop || swiper.isLocked || staticGrid) {
      var disableNav = swiper.isLocked || staticGrid || slideCount <= 1;
      prevButtons.forEach(function (btn) {
        setButtonState(btn, disableNav);
      });
      nextButtons.forEach(function (btn) {
        setButtonState(btn, disableNav);
      });
      return;
    }

    var atStart;
    var atEnd;
    var lastIndex = swiper.slides.length - 1;
    var leftmost = getEdgeSlideIndex(swiper, "start");
    var rightmost = getEdgeSlideIndex(swiper, "end");

    if (leftmost >= 0 && rightmost >= 0) {
      atStart = leftmost <= 0;
      atEnd = rightmost >= lastIndex;
    } else if (swiper.snapGrid && swiper.snapGrid.length > 1) {
      atStart = swiper.snapIndex <= 0;
      atEnd = swiper.snapIndex >= swiper.snapGrid.length - 1;
    } else {
      atStart = swiper.isBeginning;
      atEnd = swiper.isEnd;
    }

    prevButtons.forEach(function (btn) {
      setButtonState(btn, atStart);
    });
    nextButtons.forEach(function (btn) {
      setButtonState(btn, atEnd);
    });
  }

  function syncLayout(sectionEl, swiper, pcNavGroup, slideCount) {
    var mobile = isMobileLayout();
    var staticGrid = shouldUseStaticGrid(slideCount);
    var showPcNav = !mobile && slideCount > PC_VISIBLE;

    sectionEl.classList.toggle("is-static-grid", staticGrid);

    if (pcNavGroup) {
      pcNavGroup.classList.toggle("is-visible", showPcNav);
    }

    if (!swiper || swiper.destroyed) return;

    if (staticGrid) {
      swiper.allowTouchMove = false;
      return;
    }

    swiper.allowTouchMove = true;
    swiper.params.slidesPerView = mobile ? 1 : PC_VISIBLE;
    swiper.params.slidesPerGroup = 1;
    swiper.params.spaceBetween = mobile ? 0 : 24;
    swiper.update();
  }

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.blogsInit === "true") return;
    if (typeof Swiper === "undefined") return;

    var swiperEl = sectionEl.querySelector(".openear-blogs-swiper");
    if (!swiperEl) return;

    var slideCount = parseInt(sectionEl.dataset.slideCount, 10) || 0;
    if (!slideCount) return;

    sectionEl.dataset.blogsInit = "true";

    var prevButtons = sectionEl.querySelectorAll(".openear-blogs-prev");
    var nextButtons = sectionEl.querySelectorAll(".openear-blogs-next");
    var paginationEl = sectionEl.querySelector(".openear-blogs-pagination");
    var pcNavGroup = sectionEl.querySelector(".pc-nav-group");
    var swiper = null;
    var lastMobile = isMobileLayout();

    function bindNavButtons() {
      prevButtons.forEach(function (btn) {
        if (btn.dataset.blogsNavBound === "true") return;
        btn.dataset.blogsNavBound = "true";
        btn.addEventListener("click", function () {
          if (!swiper || swiper.destroyed || btn.classList.contains("is-disabled")) return;
          swiper.slidePrev();
        });
      });

      nextButtons.forEach(function (btn) {
        if (btn.dataset.blogsNavBound === "true") return;
        btn.dataset.blogsNavBound = "true";
        btn.addEventListener("click", function () {
          if (!swiper || swiper.destroyed || btn.classList.contains("is-disabled")) return;
          swiper.slideNext();
        });
      });
    }

    function destroySwiper() {
      if (swiper && !swiper.destroyed) {
        swiper.destroy(true, true);
      }
      swiper = null;
    }

    function createSwiper() {
      destroySwiper();

      var mobile = isMobileLayout();
      var staticGrid = shouldUseStaticGrid(slideCount);
      var enableLoop = shouldEnableLoop(slideCount, staticGrid);

      swiper = new Swiper(swiperEl, {
        slidesPerView: mobile ? 1 : PC_VISIBLE,
        spaceBetween: mobile ? 0 : 24,
        slidesPerGroup: 1,
        loop: enableLoop,
        loopedSlides: enableLoop ? slideCount : 0,
        loopAdditionalSlides: enableLoop ? Math.max(slideCount, PC_VISIBLE) : 0,
        speed: 450,
        allowTouchMove: true,
        watchOverflow: !enableLoop,
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,
        pagination: paginationEl
          ? {
              el: paginationEl,
              clickable: true
            }
          : undefined,
        breakpoints: {
          768: {
            slidesPerView: PC_VISIBLE,
            spaceBetween: 24,
            slidesPerGroup: 1
          }
        },
        on: {
          init: function () {
            syncLayout(sectionEl, this, pcNavGroup, slideCount);
            updateNavState(this, prevButtons, nextButtons, slideCount);
            requestAnimationFrame(function () {
              updateNavState(this, prevButtons, nextButtons, slideCount);
            }.bind(this));
          },
          slideChange: function () {
            updateNavState(this, prevButtons, nextButtons, slideCount);
          },
          slideChangeTransitionEnd: function () {
            updateNavState(this, prevButtons, nextButtons, slideCount);
          },
          resize: function () {
            updateNavState(this, prevButtons, nextButtons, slideCount);
          },
          breakpoint: function () {
            updateNavState(this, prevButtons, nextButtons, slideCount);
          },
          setTranslate: function () {
            updateNavState(this, prevButtons, nextButtons, slideCount);
          },
          transitionEnd: function () {
            updateNavState(this, prevButtons, nextButtons, slideCount);
          },
          touchEnd: function () {
            updateNavState(this, prevButtons, nextButtons, slideCount);
          }
        }
      });
    }

    function setup() {
      syncLayout(sectionEl, swiper, pcNavGroup, slideCount);

      if (shouldUseStaticGrid(slideCount)) {
        destroySwiper();
        prevButtons.forEach(function (btn) {
          setButtonState(btn, true);
        });
        nextButtons.forEach(function (btn) {
          setButtonState(btn, true);
        });
        return;
      }

      if (!swiper) {
        createSwiper();
      } else {
        syncLayout(sectionEl, swiper, pcNavGroup, slideCount);
        updateNavState(swiper, prevButtons, nextButtons, slideCount);
      }
    }

    bindNavButtons();

    sectionEl.addEventListener("click", function (event) {
      var card = event.target.closest(".card");
      if (!card || !sectionEl.contains(card)) return;

      var titleEl = card.querySelector(".card-title");
      var cardTitle = titleEl && titleEl.textContent ? titleEl.textContent.trim() : "";
      if (!cardTitle) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: "ga4Event",
        event_name: "select_content",
        event_parameters: {
          content_type: "blog",
          content_name: cardTitle,
          button_name: cardTitle
        }
      });
    });

    setup();

    window.addEventListener("resize", function () {
      var wasStatic = sectionEl.classList.contains("is-static-grid");
      var isStatic = shouldUseStaticGrid(slideCount);
      var mobile = isMobileLayout();

      if (wasStatic !== isStatic || lastMobile !== mobile) {
        lastMobile = mobile;
        setup();
        return;
      }

      syncLayout(sectionEl, swiper, pcNavGroup, slideCount);
      updateNavState(swiper, prevButtons, nextButtons, slideCount);
    });
  }

  function initAll() {
    document.querySelectorAll(".section-openear-blogs").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector(".section-openear-blogs");
    if (section) initSection(section);
  });
})();
